"use strict";

import {schemeCategory10} from '../../utils/schemeCategory10';


export function series(props, horizontal) {
    let {
        data,
        dataSeriesConfig,
        x,
        y,
        categoricalColors
    } = props;

    categoricalColors = categoricalColors || schemeCategory10;

    return dataSeriesConfig.map((f, i) => {

        // set name if not set
        f.name = f.name || f.field;
        f.customStyle = f.customStyle || null;
        f.values = f.values || null;
        // mapping throught data set x, y data
        let mapping = data.map(d => {
            if(!horizontal) {
                return {
                    x: x(d),
                    y: y(d[f.field]),
                    name: f.name,
                    field: f.field,
                    color: d.color,
                }
            }else {
                return {
                    y: y(d),
                    x: x(d[f.field]),
                    name: f.name,
                    field: f.field,
                    color: d.color,
                }
            }
        });

        return Object.assign(f, {data: mapping});
    });
}
